import React from "react";
import siteConfig from "../config/siteConfig";
import PolicyLayout from "./PolicyLayout";

const returnSections = [
  {
    title: "Our fresh-food promise",
    body: [
      `We inspect and pack every order with care. If an item arrives damaged, unsafe to consume or different from what you ordered, email ${siteConfig.contact.email} within 24 hours of delivery so we can put it right.`,
      "Please keep the product and its packaging chilled while we review the issue. Depending on the circumstances, we may offer a replacement, store credit or a refund to the original payment method.",
    ],
  },
  {
    title: "What to include",
    body: [
      "A few details help our customer care team resolve a problem quickly.",
    ],
    items: [
      "Your order reference and the email used at checkout.",
      "The name of the affected item and a short description of the issue.",
      "Clear photographs of the product, outer packaging and date or batch label.",
      "Whether the parcel was refrigerated immediately after delivery.",
    ],
  },
  {
    title: "Change-of-mind returns",
    body: [
      "For food safety reasons, chilled, frozen, fresh, opened or personalised products cannot be returned because you changed your mind.",
      "An unopened, shelf-stable item may be eligible for return within seven days of delivery when it remains unused, sealed and in resalable condition. Contact us before bringing or sending anything back; unapproved returns may not be accepted.",
    ],
  },
  {
    title: "Natural variation",
    body: [
      "Artisan food is made in small batches, so colour, rind, marbling, shape and exact weight can vary slightly. These natural differences are not normally defects. When an item is sold by approximate weight, the product listing explains the expected range.",
    ],
  },
  {
    title: "Refund timing",
    body: [
      "Once approved, refunds are sent to the original payment method. Bank and card processing times vary, so the credit may take several business days to appear after we issue it.",
      "Delivery fees are refunded only when the complete order was affected by our error or was not delivered. This policy does not limit any rights you have under applicable Hong Kong law.",
    ],
  },
  {
    title: "Cancelling an order",
    body: [
      `Contact us as soon as possible at ${siteConfig.contact.email}. We can usually cancel a standard shop order before packing begins, but supplier pre-orders, personalised items and orders already prepared or dispatched may not be cancellable.`,
    ],
  },
];

function Returns() {
  return (
    <PolicyLayout
      title="Returns & refunds"
      intro="Fresh food needs a little extra care. This policy explains what to do when an order is not right."
      sections={returnSections}
    />
  );
}

export default Returns;
